import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { CartFunnelOnBehalfUserPhoneItemBlockConfig } from '@front-platform/content-builder';
import { cartFunnelOnBehalfUserPhoneItemBlockResolveConfig } from '@front-platform/content-builder';
import { take } from 'rxjs/operators';
import { Component, OnInit, input } from '@angular/core';

import { DoodCartFunnelValueTarget } from '@store/cart-funnel/cart-funnel.model';
import { CartFunnelStoreSelector } from '@common/selectors/cart-funnel.selector';
import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';
export interface CartFunnelOnBehalfUserPhoneItemBlockRuntimeConfig {
  'block_id'?: string;
  'form_id'?: string;
}

export type CartFunnelOnBehalfUserPhoneItemBlockConfigInput = Partial<
  Omit<
    CartFunnelOnBehalfUserPhoneItemBlockConfig,
    keyof CartFunnelOnBehalfUserPhoneItemBlockRuntimeConfig
  > &
    CartFunnelOnBehalfUserPhoneItemBlockRuntimeConfig
>;
export type CartFunnelOnBehalfUserPhoneItemBlockResolvedConfig = Omit<
  CartFunnelOnBehalfUserPhoneItemBlockConfig,
  keyof CartFunnelOnBehalfUserPhoneItemBlockRuntimeConfig
> &
  Partial<CartFunnelOnBehalfUserPhoneItemBlockRuntimeConfig>;
export interface CartFunnelOnBehalfUserPhoneItemBlockContract extends ConfigComponentContract<
  CartFunnelOnBehalfUserPhoneItemBlockConfigInput,
  CartFunnelOnBehalfUserPhoneItemBlockResolvedConfig
> {}

@Component({
  selector: 'app-cart-funnel-on-behalf-user-phone-item-block',
  templateUrl: './cart-funnel-on-behalf-user-phone-item-block.component.html',
  standalone: false,
})
export class CartFunnelOnBehalfUserPhoneItemBlockComponent
  implements OnInit, CartFunnelOnBehalfUserPhoneItemBlockContract
{
  readonly config = input<CartFunnelOnBehalfUserPhoneItemBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    CartFunnelOnBehalfUserPhoneItemBlockConfig,
    CartFunnelOnBehalfUserPhoneItemBlockRuntimeConfig
  >(cartFunnelOnBehalfUserPhoneItemBlockResolveConfig, () => ({ config: this.config() }));
  get title(): string {
    return this.resolvedConfig()['title'] as unknown as string;
  }
  get placeholder(): string {
    return this.resolvedConfig()['placeholder'] as unknown as string;
  }
  get required(): boolean {
    return this.resolvedConfig()['required'] as unknown as boolean;
  }
  get blockId(): string {
    return this.resolvedConfig()['block_id'] as unknown as string;
  }
  get formId(): string {
    return this.resolvedConfig()['form_id'] as unknown as string;
  }

  value = '';

  constructor(
    private cartFunnelSelector: CartFunnelStoreSelector,
    private cartFunnelDispatcher: CartFunnelStoreDispatcher,
  ) {}

  ngOnInit(): void {
    this.cartFunnelDispatcher.addValue({
      id: this.blockId,
      title: this.title,
      displayTitle: true,
      formId: this.formId,
      required: this.required,
      target: DoodCartFunnelValueTarget.OnBehalfUserPhone,
    });

    this.cartFunnelSelector
      .selectValue(this.blockId)
      .pipe(take(1))
      .subscribe(form => {
        this.value = form?.value?.toString() ?? '';
      });
  }

  onValueChange(_value: string | boolean): void {
    this.cartFunnelDispatcher.updateValue({
      id: this.blockId,
      changes: {
        value: _value,
      },
    });
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(CartFunnelOnBehalfUserPhoneItemBlockComponent, {
  'keyAliases': {},
});
